<script lang="ts">
	import type { IStats } from 'customTypes/coinDetails';
	import formatNumber from 'utils/formatNumber';
	import activeCurrency from 'stores/activeCurrency';
	import { _ } from 'utils/i18/i18n';
	import type { ICurrencyData } from 'customTypes/currencyData';
	export let data: IStats;
	export let dark: boolean;
	export let yearPriceChange: number;
	export let coinsAmount: number;
	export let copywrite;
	export let marketNames: string[];

	let isAllTextShown = false;
	let textRef;
	let volumeTrade: number;
	let marketCap: number;
	let currencyData = $activeCurrency as ICurrencyData;
	$: currencyData = $activeCurrency;
	$: isSame = data.id === currencyData.currency.toUpperCase();

	function calculateTradeVolume(data: string) {
		return formatNumber(Number(data) * currencyData.price, currencyData.currency);
	}
	function calculateMarketCap(data: string) {
		return formatNumber(Number(data) * currencyData.price, currencyData.currency);
	}

	$: currencyData,
		(volumeTrade = data['1d'] ? calculateTradeVolume(data['1d']?.volume) : 0),
		(marketCap = data.market_cap ? calculateMarketCap(data?.market_cap) : 0);

	const priceUpOrDown = data['1d']
		? Number(data['1d'].price_change_pct) > 0
			? 'up'
			: 'down'
		: 'stable';
	const percentValueUpOrDown = Number(data['1d'].price_change_pct).toFixed(2);

	const circulatingSupply = data.circulating_supply
		? formatNumber(Number(data.circulating_supply), null, false, 'decimal')
		: 0;
	const maxSupply = data.max_supply
		? `and a maximum supply of ${formatNumber(Number(data.max_supply), null, false, 'decimal')} ${
				data.symbol
		  } coins.`
		: '.';
</script>

<div class="wrapper" class:dark>
	<h2 class="title" bind:this={textRef}>{`Live ${data.name} Price Today`}</h2>
	<div class={`coin-information ${isAllTextShown ? 'open' : 'closed'}`}>
		<p class={`description `}>
			{`${$_('coinDetailed.coinDescription.theLive')} ${data.name}
				${$_('coinDetailed.coinDescription.priceToday')}
				${formatNumber(isSame ? 1 : Number(data.price), currencyData.currency)} ${$_(
				'coinDetailed.coinDescription.usdAsof',
			)}
			${new Date().toLocaleDateString('en-US')},
				${$_('coinDetailed.coinDescription.withTradingVolume')}
				${volumeTrade}.`}
			<br />
			<br />
			{`
				 ${data.name}${$_('coinDetailed.coinDescription.priceIs')} ${priceUpOrDown}
				${percentValueUpOrDown}% ${$_('coinDetailed.coinDescription.inLastHours')}`}
			<br />
			<br />
			{`${$_('coinDetailed.coinDescription.currently')}, ${data.name}
				${$_('coinDetailed.coinDescription.ranks')}
				${data.rank ? `${data.rank}` : 0}
				${$_('coinDetailed.coinDescription.outOf')}
				${coinsAmount} ${$_('coinDetailed.coinDescription.coinsAccording')}`}
			<br />
			<br />
			{`${data.name} ${$_('coinDetailed.coinDescription.hasLiveMarketcap')} ${
				isSame ? `${circulatingSupply} ${data.symbol}` : marketCap
			},
				${$_('coinDetailed.coinDescription.circulatingSupplyOf')} ${circulatingSupply}
				${data.symbol} 	${$_('coinDetailed.coinDescription.coins')} ${maxSupply}`}

			{#if yearPriceChange > 0}
				<br />
				<br />
				{`${$_('coinDetailed.coinDescription.inThePastYear')},
						${data.name}${$_('coinDetailed.coinDescription.priceChangeBy')}
						${Number(yearPriceChange).toFixed(2)}%.`}
			{/if}

			<br />
			<br />

			{#if marketNames.length > 0}
				{`${$_('coinDetailed.coinDescription.wantToFind')}
					${data.name}
					${$_('coinDetailed.coinDescription.atCurrentPrice')}`}

				<br />
				<br />
				{`
					${$_('coinDetailed.coinDescription.topCryptoExchanges')}
					${data.name}
					${$_('coinDetailed.coinDescription.coinsAreCurrently')} ${marketNames.join(', ')}.
					${$_('coinDetailed.coinDescription.othermarkets')}
			`}
				<a href="/exchanges" class="link">{`${$_('coinDetailed.coinDescription.cryptoExchanges')}`}</a>
				{`${$_('coinDetailed.coinDescription.page')}`}
			{/if}
		</p>
		{#if copywrite}
			<div class="copywrite">
				{@html copywrite}
			</div>
		{/if}
	</div>

	<button
		class="btn"
		on:click={() => {
			if (isAllTextShown)
				textRef.scrollIntoView({
					behavior: 'smooth',
				});
			isAllTextShown = !isAllTextShown;
		}}>{isAllTextShown ? 'Hide' : 'Read more'}</button
	>
</div>

<style lang="scss">
	@import 'coinDescription';
</style>
